import httpRequest from '../../utils/httpRequest';
import API from '@/api';

const SERVER_NAME = 'logistics/carrierUnit';
/**
 * 承运商列表
 */
export function queryPage(data) {
    return httpRequest({
        url: '/queryPage',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 新增承运商开户
 * * @param {Object} data
 */
export function add(data) {
    return httpRequest(
        {
            url: '/save',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            resolveError: true,
        }
    );
}
/**
 * 获取详情
 */
export function get(params) {
    return httpRequest({
        url: '/get',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 禁用/恢复承运商
 */
export function updateBlacklist(data) {
    return httpRequest({
        url: '/updateBlacklist',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}
/**
 * 删除承运商
 */
export function deleteList(params) {
    return httpRequest({
        url: '/delete',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 承运商工作台
 */
export function carrierWorkBench(params) {
    return httpRequest({
        url: '/carrierWorkBench',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
